import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useLayoutEffect, useState } from "react";

import MainContainer from "../../../components/container/MainContainer";
import { getProject, unsetProjects } from "../../../features/projectsSlice";
import PageTitle from "../../../components/titles/PageTitle";
import { openModal } from "../../../features/modalSLice";
import Loading from "../../../components/loading/Loading";
import Modal from "../../../components/modal/Modal";
import PDFComponent from "../../../components/pdf/PDFComponent";
import AddPDOPlanningApproval from "./AddPDOPlanningApproval";
import LinkTextContainer from "../../../components/text/LinkTextContainer";
import { useAuthorization } from "../../../hooks/useAuthorization";
import ProposalComp from "../../../components/projects/ProposalComp";
import useProposalApplication from "../../../hooks/useProposalApplication";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";

const PDOProposalReview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const project = useSelector((state) => state.projects.selected); // List of ongoing projects
  const modalContent = useSelector((state) => state.modal.content);
  const loading = useSelector((state) => state.projects.load.getProject);
  // const [data, setData] = useState([]);

  const openApproveProvincial = () => {
    dispatch(
      openModal(<AddPDOPlanningApproval id={project.id} name={project.name} />)
    );
  };

  useLayoutEffect(() => {
    if (id) {
      dispatch(getProject(id));
    }
    return () => {
      dispatch(unsetProjects());
    };
  }, []);

  useLayoutEffect(() => {
    if (
      (project.id && project?.stage?.step_number < 11) ||
      (project.id && project?.stage?.step_number > 11)
    ) {
      return navigate("/requests/pdo-approvals", { replace: true });
    }
  }, [project, navigate]);

  //Construct Data for PDF proposal
  const data = useProposalApplication({ project });

  if (
    loading === loadStatus.loading ||
    (!project.id && loading === loadStatus.loading)
  ) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <div className="w-full max-w-5xl mx-auto text-text-1/70">
        <div className="sm:flex justify-between items-center py-4">
          <PageTitle title="PDO - Proposal Review & Approval" />
          <PDFComponent
            title={project.name + ", PDO Proposal review"}
            data={data}
          />
        </div>
        {project.id && (
          <>
            <div className="mx-auto max-w-5xl w-full bg-content shadow-md px-5 py-6 flex flex-col gap-0.5 ">
              <ProposalComp project={project} />

              {/* Documents */}

              <LinkTextContainer
                document={project.proposal_community_council_minute}
                role="Community"
                title="Community Council Minutes: "
              />

              <LinkTextContainer
                document={project.proposal_provincial_council_minute}
                role="Provincial"
                title="Provincial Council Minutes: "
              />
            </div>

            {/* Action Buttons  */}

            <div className="max-w-5xl w-full mx-auto">
              <div className="flex justify-between items-center pt-4 pb-10">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/requests/provincial-approvals");
                  }}
                  className="cancel-rss-btn"
                >
                  Back
                </button>
                <div className="flex gap-2">
                  <button
                    type="button"
                    onClick={openApproveProvincial}
                    className="add-rss-btn"
                    disabled={!isAuthorized("pdo_department", "update")}
                  >
                    Send Letter
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </MainContainer>
  );
};

export default PDOProposalReview;
